import { MainData } from "../interfaces/intakes.reports";

function objToArray(objeto:MainData) {
    const restArray = Object.entries(objeto)
    return restArray
}

export default objToArray


export const objectToCheckArray = ( originalObject: MainData, finalObject?:MainData ) => {

    const array = [];
    const exclude = [ "supplier", "grower", "gln_ggn", "samples", "pallet_ref", "unit_label", "order_line", "ggn" ]

    for (const key in originalObject) {
      if (originalObject.hasOwnProperty(key)) {
        array.push({check: exclude.includes(key) ? false : true, key, value: originalObject[key] || ""});
        // array.push({check: (!exclude.includes(key) || finalObject?.[key]) ? true : false, key, value: originalObject[key] || ""});
      }
    }

    // Si viene un finalObject, entonces comparamos con el original y sacamos el check en caso que no venga esa propiedad en finalObject
    if (finalObject) {
       array.map( item => {
        if (!(item.key in finalObject)) item.check = false
        return item
       })
    }

    return array;
  };

// export const objectToCheckArray = ( originalObject, finalObject ) => {

//     const array = [];
//     const exclude = [ "supplier", "grower", "gln_ggn", "samples", "pallet_ref", "unit_label" ]

//     for (const key in originalObject) {
//       if (originalObject.hasOwnProperty(key)) {
//         array.push({check: exclude.includes(key) ? false : true, key, value: originalObject[key]});
//       }
//     }
//     return array;
//   };

  export const objectToArray = ( object:MainData ) => {
    const array = [];
    for (const key in object) {
      if( !object[key] ) continue;
      if( object.hasOwnProperty(key) ) {
        array.push({ key, value: object[key] || "" });
      }
    }
    return array;
  };


  export const arrayCheckedToObject = (checkedMainData: any[]) => {
  return checkedMainData.reduce((acc, item) => {
    acc[item.key] = item.value;
    return acc;
  }, {});
};